import React, { useState, useEffect } from 'react';
import { Send, CheckCircle2, ArrowLeft, Mail } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import './Contact.css';

const Contact = ({ currentProfile }) => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  
  // URL Formspree (à remplacer plus tard par l'utilisateur)
  const FORMSPREE_URL = "https://formspree.io/f/xlgqapbl";

  const [formData, setFormData] = useState({
    firstName: currentProfile?.name ? currentProfile.name.split(' ')[0] : '',
    lastName: currentProfile?.name && currentProfile.name.includes(' ') ? currentProfile.name.substring(currentProfile.name.indexOf(' ') + 1) : '',
    email: '',
    subject: '',
    message: ''
  });

  useEffect(() => {
    if (!currentProfile) {
      document.getElementById('root').classList.add('full-width');
    }
    return () => {
      document.getElementById('root').classList.remove('full-width');
    };
  }, [currentProfile?.id]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const payload = {
        ...formData,
        _subject: `Nouveau message de ${formData.firstName} ${formData.lastName} - ${formData.subject}`
      };

      const response = await fetch(FORMSPREE_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        setIsSuccess(true);
        setFormData({
          firstName: '', lastName: '', email: '', subject: '', message: ''
        });
      } else {
        alert("Une erreur est survenue. N'as-tu pas oublié de configurer Formspree ?");
      }
    } catch (error) {
      alert("Erreur de connexion.");
    }

    setIsSubmitting(false);
  };

  return (
    <div className={`contact-page fade-in ${!currentProfile ? 'public-view' : ''}`}>
      {/* Arrière-plan décoratif */}
      <div className="contact-bg-blobs">
        <div className="contact-blob blob-1"></div>
        <div className="contact-blob blob-2"></div>
        <div className="contact-blob blob-3"></div>
      </div>

      {!currentProfile && (
        <div className="contact-header-nav">
          <button 
            className="btn btn-outline" 
            onClick={() => { window.scrollTo(0, 0); navigate('/'); }} 
            style={{ 
              display: 'inline-flex', 
              alignItems: 'center', 
              gap: '0.5rem' 
            }}
          >
            <ArrowLeft size={18} /> Retour
          </button>
        </div>
      )}

      <div className="contact-container">
        <div className="contact-info">
          <h1>Contacte-nous !</h1>
          <p>
            Une question, une suggestion, ou un bug à signaler ? 
            N'hésite pas à nous envoyer un message via ce formulaire. 
            Notre équipe te répondra dans les plus brefs délais à l'adresse <a href="mailto:contact@masse-terclass.com" style={{ color: 'var(--primary-color)', fontWeight: 'bold', textDecoration: 'none' }}>contact@masse-terclass.com</a>.
          </p>
          
          <div className="contact-illustration">
            <Mail size={80} color="var(--primary-color)" />
          </div>
        </div>

        <div className="contact-form-card glass-panel">
          {isSuccess ? (
            <div className="success-state fade-in">
              <CheckCircle2 size={64} color="var(--secondary-color)" />
              <h2>Message envoyé !</h2>
              <p>Merci pour ton message. Nous reviendrons vers toi très vite.</p>
              <p style={{ marginTop: '1rem', fontWeight: 600, color: 'var(--text-secondary)' }}>
                En attendant, va entraîner tes muscles :)
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="firstName">Prénom</label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                    placeholder="Ton prénom"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="lastName">Nom</label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                    placeholder="Ton nom"
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="email">Adresse Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="ton@email.com"
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject">Objet</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  placeholder="Sujet de ton message"
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="5"
                  placeholder="Écris ton message ici..."
                ></textarea>
              </div>

              <button 
                type="submit" 
                className={`btn btn-primary submit-btn ${isSubmitting ? 'loading' : ''}`}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Envoi en cours...' : (
                  <>
                    <span>Envoyer le message</span>
                    <Send size={18} className="send-icon" />
                  </>
                )}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default Contact;
